/*
 * @version: 
 * @Author: Cuidezhen
 * @Date: 2023-04-19 13:58:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-28 16:19:54
 * @company: 医视界
 * @FilePath: \village_platform\src\pages\createOperateUser\index.tsx
 * @Descripttion: 
 * @Edit Record: 
 */
import React, {useCallback, useState, useEffect} from 'react'
import { store } from "@root/store/index";
import { Select, Form, Button, Table, Input, Pagination, message, Space, Modal, Radio, Upload } from 'antd';
import { getNewsEditList, addNewsUser, setNewsUser, delNewsUser, resetNewsUserPwd, downloadNewsExcel } from "@root/common/service";
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import axios from "axios";

const { Option } = Select;
const { NODE_ENV } = process.env;
const prefixpath = NODE_ENV === "development" ? "" : "/county-manager";
interface DataType {
  key: number|string;
  nickName: string;
  sex: number|string;
  phonenumber: number|string;
  baseUserIdCategory: string;
  identityNumber: number|string;
  orgName: string;
}
function Index() {

  const columns: ColumnsType<DataType> = [
    {
      title: '序号',
      // dataIndex: 'number',
      // key: 'number',
      render:(text, record, index) => `${index + 1}`
    },
    {
      title: '姓名',
      dataIndex: 'nickName',
      key: 'nickName',
    },
    {
      title: '性别',
      dataIndex: 'sex',
      key: 'sex',
      render: (_, a) => (
        <>
        {(()=>{
          if(a.sex == 0){
            return '男'
          }else{
            return '女'
          }
        })()}
        </>
      ),
    },
    {
      title: '手机号',
      dataIndex: 'phonenumber',
      key: 'phonenumber',
    },
    {
      title: '证件类型',
      dataIndex: 'baseUserIdCategory',
      key: 'baseUserIdCategory',
      render: (_, a) => (
        <>
        {(()=>{
          if(a.baseUserIdCategory == '0'){
            return '居民身份证'
          }else{
            return '其他'
          }
        })()}
        </>
      ),
    },
    {
      title: '证件号码',
      dataIndex: 'identityNumber',
      key: 'identityNumber',
    },
    {
      title: '工作单位',
      dataIndex: 'orgName',
      key: 'orgName',
    },
    {
      title: '操作',
      dataIndex: 'set',
      key: 'set',
      render: (_,e)=> (
        <Space size="middle">
          <Button style={{padding: '0'}} onClick={()=>edit(e)} type="link">编辑</Button>
          <Button style={{padding: '0'}} onClick={()=>del(e)} type="link">删除</Button>
          <Button style={{padding: '0'}} onClick={()=>reset(e)} type="link">重置密码</Button>
        </Space>
      ),
    },
  ]
  
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [data, setData] = useState<DataType[]>();
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState<number>()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState('添加角色账号')
  const [phoneDisabled, setPhoneDisabled] = useState(false)
  const [editItem, setEditItem] = useState<any>({})
  const [fileList, setFileList] = useState<any>([]);

  useEffect(()=>{  
    getTableData()
  },[current])

  const getTableData = async(e: string = '')=>{
    const { rows, total } = await getNewsEditList(`${e}instituteId=${store.getState().userInfo.instituteId}&pageNum=${current}&pageSize=10`)
    rows.forEach((e: any, index: number) => {
      e.key = index
    });
    setData(rows)
    setTotal(total)
  }

  const onFinish = useCallback((e: any)=>{
    const keys: Array<string> = Object.keys(e)
    const values = Object.values(e)
    const str: string = values.reduce(function(r: string,el,i){
      if(!!el){ r+=`${keys[i]}=${el}&` }
      return r
    },'')
    getTableData(str)
  },[])

  const onFinishFailed = useCallback((e: any)=>{
    console.log(e);
  },[])

  const onReset = useCallback(()=>{
    setCurrent(1)
    form1.resetFields();
    getTableData()
  },[form1])

  const add = useCallback(()=>{
    setPhoneDisabled(false)
    setModalTitle('添加角色账号')
    setIsModalOpen(true)    
  },[])

  const imports = useCallback(()=>{
    console.log('imports');
  },[])


  const download = useCallback(()=>{
    console.log('download');
    const downloadOne = async () => {
      const { rows, code } = await downloadNewsExcel();
      if (code === 200) {
        window.location.href = rows[0].exceltemplateaddress;
      }
    };
    downloadOne();
  },[])

  const edit = useCallback((e: any)=>{
    console.log(e);
    setPhoneDisabled(true)
    setEditItem(e)
    form2.setFieldsValue({nickName: e.nickName, sex: e.sex, baseUserIdCategory: e.baseUserIdCategory, identityNumber: e.identityNumber, phonenumber: e.phonenumber, orgName: e.orgName})
    setModalTitle('编辑角色账号')
    setIsModalOpen(true)  
  },[])

  const del = useCallback(async(e: any)=>{
    const {code, msg} = await delNewsUser(e.userId)
    if(code == 200){
      getTableData()
      message.success('删除成功')
    }else{
      message.error(msg)
    }
  },[])

  const reset = useCallback(async(e: any)=>{
    console.log(e);
    const {code, msg} = await resetNewsUserPwd({
      userId: e.userId,
      password: '000000'
    })
    if(code == 200){
      message.success('重置成功')
    }else{
      message.error(msg)
    }
  },[])

  const onChange = (e: any)=>{
    setCurrent(e)
    getTableData()
  }
  

  const handleOk = useCallback(async(e: any)=>{
    if(phoneDisabled){
      const {code, msg} =  await setNewsUser({
        ...e,
        userId: editItem.userId
      })
      if(code == 200){
        message.success('编辑成功');
        setIsModalOpen(false)
        getTableData()
      }else{
        message.error(msg);
      }
    }else{
      const {code, msg} =  await addNewsUser({
        ...e,
        password: '000000',
        userName: e.phonenumber,
        roleIds: [21],
        instituteId: store.getState().userInfo.instituteId
      })
      if(code == 200){
        message.success('添加成功');
        setIsModalOpen(false)
        getTableData()
      }else{
        message.error(msg);
      }
    }
    form2.resetFields();
  },[phoneDisabled, editItem])
  
  const handleCancel = useCallback(()=>{
    form2.resetFields();
    setIsModalOpen(false)    
  },[])

  const handleChange = useCallback((e: any,a: any)=>{
    console.log('选择结果',e,a);
  },[])

  return (
    <div style={{padding: '15px', background: '#fff'}}>
      <div className="top">
        <Form
          name="createOperateUser"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          layout="inline"
          form={form1}
        >
          <Form.Item label="姓名" name="nickName" ><Input placeholder="请输入内容" style={{ width: 180 }}/></Form.Item>

          <Form.Item label="证件号" name="identityNumber" ><Input placeholder="请输入内容" style={{ width: 180 }}/></Form.Item>

          <Form.Item label="手机号" name="phonenumber" ><Input placeholder="请输入内容" style={{ width: 180 }}/></Form.Item>

          <Form.Item style={{marginLeft: '30px'}}>
            <Button className='searchBtn' type="primary" htmlType="submit"><SearchOutlined />查询</Button>
            <Button className='resetBtn' type="primary" onClick={onReset} style={{marginLeft: '15px'}} ><RedoOutlined />重置</Button>
          </Form.Item>
        </Form>
      </div>

      <div className='midBtn'>
        <Button type="primary" onClick={()=>add()} >添加</Button>
        <Upload 
          maxCount={1}
          accept=".xlsx"
          showUploadList={false}
          onRemove={(file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
          }}
          beforeUpload={(file) => {
            console.log(file);
            if (file.size > 307200) {
              message.error("文件不可大于300K");
              return;
            }
            const formData = new FormData();
            formData.append("file", file);
            setFileList([...fileList, file]);
            const {
              userInfo: { access_token },
            } = store.getState();
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${access_token}`,
              },
            };
            axios
              .post(
                `${prefixpath}/dev-api/system/user/editor/importData`,
                formData,
                config
              )
              .then(
                (res: any) => {
                  console.log(res);
                  if (res.data.code === 200) {
                    message.success({
                      content: `${res.data.msg}`.split("<br/>").join("\n"),
                      style: { whiteSpace: "pre-wrap" },
                    });
                    getTableData()
                  } else {
                    message.error({
                      content: `${res.data.msg}`.split("<br/>").join("\n"),
                      style: { whiteSpace: "pre-wrap" },
                    });
                  }
                },
                (err) => {
                  message.error(`${err}`);
                }
              );
            return false;
          }}
        >
          <Button type="primary" onClick={()=>imports()} >导入</Button>
        </Upload>
        <Button type="primary" onClick={()=>download()} >下载模板</Button>
      </div>

      <div className='tableBottom'>
        <Table size='middle' pagination={false} columns={columns} dataSource={data} />
        <Pagination current={current} onChange={onChange} total={total} showSizeChanger={false}/>
      </div>

      <Modal title={modalTitle} visible={isModalOpen} onCancel={handleCancel} footer={[]} bodyStyle={{display:'flex',justifyContent:'center'}}>
        <Form
          name="addUser"
          initialValues={{}}
          onFinish={handleOk}
          autoComplete="off"
          form={form2}
        >
          <Form.Item label="姓名" name="nickName" rules={[{ required: true, message: '姓名不可为空!' }]}>
            <Input placeholder="请输入内容" style={{ width: 180 }}/>
          </Form.Item>

          <Form.Item label="性别" name="sex" rules={[{ required: true, message: '性别不可为空!' }]}>
            <Radio.Group>
              <Radio value="0">男</Radio>
              <Radio value="1">女</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item label="证件类型" name="baseUserIdCategory" rules={[{ required: true, message: '证件类型不可为空!' }]}>
            <Select placeholder="请选择" onChange={handleChange} allowClear style={{ width: 180 }}>
              <Option value="0">身份证</Option>
              <Option value="1">其他</Option>
            </Select>
          </Form.Item>

          <Form.Item label="证件号" name="identityNumber" rules={[{ required: true, message: '证件号不可为空!' }]}>
            <Input placeholder="请输入内容" style={{ width: 180 }}/>
          </Form.Item>

          <Form.Item label="手机号" name="phonenumber" rules={[{ required: true, message: '手机号不可为空!' }]}>
            <Input disabled={phoneDisabled} placeholder="请输入内容" style={{ width: 180 }}/>
          </Form.Item>

          <Form.Item label="工作单位" name="orgName" rules={[{ required: true, message: '工作单位不可为空!' }]}>
            <Input placeholder="请输入内容" style={{ width: 180 }}/>
          </Form.Item>

          <Form.Item style={{display: 'flex', justifyContent: 'center'}}>
            <Button onClick={handleCancel} style={{marginRight: '15px'}}>取消</Button>
            <Button type="primary" htmlType="submit">确定</Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Index